const e = "_shapeWrapper_1dinr_1", a = "_shapeImage_1dinr_9", p = "_shape_1dinr_1", s = {
  shapeWrapper: e,
  shapeImage: a,
  shape: p
};
export {
  s as default,
  p as shape,
  a as shapeImage,
  e as shapeWrapper
};
